import { z } from "zod";

export const ClientValidationSchema = z.object({
    clientId: z.string().min(1),
    displayName: z.string().min(1),
    clientSecret: z.string().nullable(),
    clientType: z.string().min(1),
    redirectUris: z.array(z.string()).min(1),
    postLogoutRedirectUris: z.array(z.string()).min(1),
    permissions: z.array(z.string()).min(1),
    requirements: z.array(z.string()).nullable(),
});
